import { WorkflowStepCode } from '@exam-room/graphql/preview';

export enum ReviewResultVariant {
  HIDDEN = 'HIDDEN',
  EDITABLE = 'EDITABLE',
  READONLY = 'READONLY',
}

interface ReviewResultRoles {
  isOwner: boolean;
  isAssigner: boolean;
  isAssignee: boolean;
}

interface ReviewResultTask {
  assignerId: string;
  assignee: { id: string };
  parentTask: { ownerId: string } | null;
}

const assigneeVariant: Partial<Record<WorkflowStepCode, ReviewResultVariant>> = {
  [WorkflowStepCode.ReviewQsetTodo]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetInReview]: ReviewResultVariant.EDITABLE,
  [WorkflowStepCode.ReviewQsetReviewed]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetDone]: ReviewResultVariant.READONLY,
};

const otherVariant: Partial<Record<WorkflowStepCode, ReviewResultVariant>> = {
  [WorkflowStepCode.ReviewQsetTodo]: ReviewResultVariant.HIDDEN,
  [WorkflowStepCode.ReviewQsetInReview]: ReviewResultVariant.HIDDEN,
  [WorkflowStepCode.ReviewQsetReviewed]: ReviewResultVariant.READONLY,
  [WorkflowStepCode.ReviewQsetDone]: ReviewResultVariant.READONLY,
};

export function getReviewResultRoles(
  userId: string,
  task: ReviewResultTask | null | undefined,
): ReviewResultRoles {
  if (!userId || !task) {
    return { isOwner: false, isAssigner: false, isAssignee: false };
  }

  return {
    // REMARK: the real owner of a subtask is the owner of its parent task
    isOwner: userId === task.parentTask?.ownerId,
    isAssigner: userId === task.assignerId,
    isAssignee: userId === task.assignee.id,
  };
}

export function getReviewResultVariant(
  roles: ReviewResultRoles,
  workflowStepCode: WorkflowStepCode | null | undefined,
): ReviewResultVariant | null {
  if (roles.isAssignee) {
    // REMARK: assignee takes precedence even when also assigner
    return assigneeVariant[workflowStepCode as WorkflowStepCode] ?? ReviewResultVariant.READONLY;
  }

  if (roles.isAssigner || roles.isOwner) {
    return otherVariant[workflowStepCode as WorkflowStepCode] ?? ReviewResultVariant.READONLY;
  }

  return null;
}
